/**
 * Everything the demo stores is under `cg.*` (contract §3). When the shape
 * changes, bump the version: every `cg.*` key is cleared once, on load, before
 * anything reads one.
 */

export const STORAGE_VERSION = '1';
const VERSION_KEY = 'cg.version';

export function ensureStorageVersion(): void {
  try {
    if (localStorage.getItem(VERSION_KEY) === STORAGE_VERSION) return;
    const doomed: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith('cg.')) doomed.push(key);
    }
    doomed.forEach((key) => localStorage.removeItem(key));
    localStorage.setItem(VERSION_KEY, STORAGE_VERSION);
  } catch {
    // Site data blocked: nothing stored, nothing to clear.
  }
}
